import { ClaInsights } from '@models';

export interface ClaInsightsResult {
  easyClaInsights: ClaInsights;
}
